import { h } from 'preact';

const MenuItem = ({ link }) => (
    <li
      className='flex items-center'
    >
      <a
        href={link.url}
        className={
          'link-unstyled font-16 laptop:font-14 text-white/90 laptop:text-white/60 hover:text-white'
        }
      >
        {link.title}
      </a>
    </li>
  );

export default MenuItem;
